import { render, staticRenderFns } from "./RecordsOfCourse.vue?vue&type=template&id=4c075581&"
import script from "./RecordsOfCourse.vue?vue&type=script&lang=js&"
export * from "./RecordsOfCourse.vue?vue&type=script&lang=js&"
import style0 from "./RecordsOfCourse.vue?vue&type=style&index=0&id=4c075581&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports